import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Loader } from 'lucide-react';

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { usuario, loading, isAuthenticated, isAdmin } = useAuth();

  // Mostrar loading enquanto verifica autenticação
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 flex items-center justify-center">
        <div className="text-center">
          <Loader className="w-8 h-8 text-blue-500 animate-spin mx-auto mb-4" />
          <p className="text-slate-400">Verificando autenticação...</p>
        </div>
      </div>
    );
  }

  // Se não está autenticado, não renderizar nada (App.js redirecionará para Auth)
  if (!isAuthenticated()) {
    return null;
  }

  // Se requer admin e usuário não é admin
  if (adminOnly && !isAdmin()) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 flex items-center justify-center p-4">
        <div className="text-center">
          <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-red-400 text-2xl">!</span>
          </div>
          <h2 className="text-xl font-bold text-white mb-2">Acesso Negado</h2>
          <p className="text-slate-400">Você não tem permissão para acessar esta área.</p>
        </div>
      </div>
    );
  }

  // Renderizar conteúdo protegido
  return children;
}; 